export default __webpack_public_path__ + "d73e5a112d0521f7672fb2ffd41205fa.png";